export const HOME_PATH = 'home'
export const LOGIN_PATH = 'login'
export const LOGOUT_PATH = 'logout'
export const QR_PATH = 'qr'
export const AUTH_PATH = 'auth'
export const USERS_PATH = 'users'
export const PROJECT_PATH = 'project'


export const ACCESS_TOKEN_KEY = 'samtycke-at'